import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';
import { AnimatedFabDirective } from './directives/animated-fab.directive';
import { InfoComponent } from './info/info.component';
import { MainHeaderComponent } from './main-header/main-header.component';
import { UsernameModalComponent } from './username-modal/username-modal.component';

@NgModule({
	imports: [IonicModule, CommonModule, FormsModule, RouterModule, ReactiveFormsModule],
	declarations: [MainHeaderComponent, InfoComponent, AnimatedFabDirective, UsernameModalComponent],
	exports: [MainHeaderComponent, InfoComponent, AnimatedFabDirective, UsernameModalComponent],
})
export class HelpersModule {}
